const callDetails = {
  'callDetails.empty':
    'Here you can check out the details of any previous call.',
  'callDetails.events.empty': 'No events were registered during this call.',
};

export default callDetails;
